import { Injectable } from '@angular/core';

import { PopperContentComponent } from '@frontend/vanilla/features/popper';
import { Store } from '@ngrx/store';

import { MarketHeaderTooltipService } from '../market-header-tooltip/market-header-tooltip.service';
import { IUiChangeHandler } from '../ui-manager/ui-change-handler';
import { UiManagerActions } from '../ui-manager/ui-manager.actions';
import { UiManagerService } from '../ui-manager/ui-manager.service';
import { IUiRootState, IUiState } from '../ui-manager/ui-manager.state';
import { UiStates } from '../ui-manager/ui-states.enum';

@Injectable({ providedIn: 'root' })
export class MarketSubTypeTooltipService implements IUiChangeHandler {
    constructor(
        private store: Store<IUiRootState>,
        private uiManager: UiManagerService,
        private marketHeaderTooltipService: MarketHeaderTooltipService,
    ) {
        this.uiManager.registerUiHandler(this);
    }

    set tooltip(popper: PopperContentComponent) {
        if (!this.marketHeaderTooltipService.tooltip) {
            this.store.dispatch(UiManagerActions.addState({ state: UiStates.MarketSubTypeTooltipShown }));
        }

        this.marketHeaderTooltipService.tooltip = popper;
    }

    updateUi(prevState: IUiState, nextState: IUiState): void | Promise<any> {
        if (this.isStateRemoved(prevState, nextState, UiStates.MarketSubTypeTooltipShown)) {
            this.closeTooltip();
        }
    }

    closeTooltip(): void {
        this.marketHeaderTooltipService.closeTooltip();
    }

    private isStateRemoved(prev: IUiState, next: IUiState, state: UiStates): boolean {
        return !!(prev && prev.states.some((s) => s === state) && (!next || next.states.every((s) => s !== state)));
    }
}
